/**
 * Translations for the chat feature area.
 * Covers ChatPage and VoiceBottleModal.
 */
const chat = {
  zh: {
    // ChatPage — empty/no-pet state
    'chat.empty.noPet.title': '先领养一只宠物',
    'chat.empty.noPet.helper': '有了朋友才能聊天呀～',
    'chat.empty.noPet.cta': '🐾 去领养',

    // ChatPage — empty conversation
    'chat.empty.greet': '和 {name} 说说话吧～',

    // ChatPage — input
    'chat.input.placeholder': '对 {name} 说...',

    // ChatPage — budget warning
    'chat.budget.nearLimit': 'AI 今天聊得有点多了，剩余预算快用完，明天会更有活力哦～',

    // ChatPage — error fallback
    'chat.error.generic': '出错了',

    // VoiceBottleModal — header
    'chat.bottle.title': '悄悄话留言瓶',
    'chat.bottle.subtitle': '说一句话给 {name}，它会一直记得',
    'chat.bottle.close.aria': '关闭',

    // VoiceBottleModal — idle / record
    'chat.bottle.hint': '按住贝壳说话，松开就送进瓶子里',
    'chat.bottle.recordHold': '按住录音',
    'chat.bottle.recordRelease': '松开结束',

    // VoiceBottleModal — recording info
    'chat.bottle.timer': '{seconds}s · 最长 {max}s',
    'chat.bottle.duration': '{seconds} 秒',

    // VoiceBottleModal — preview
    'chat.bottle.preview.recorded': '✨ 录好啦！时长 {duration}',
    'chat.bottle.preview.noTranscript': '（这次没识别出文字，但 {name} 还是会记住你录了一段悄悄话）',
    'chat.bottle.preview.redo': '重录',
    'chat.bottle.preview.save': '装进瓶子',

    // VoiceBottleModal — saving
    'chat.bottle.saving': '让 {name} 听一听…',

    // VoiceBottleModal — list
    'chat.bottle.list.title': '瓶子里 ({count})',
    'chat.bottle.list.empty': '还没有留言哦～按住贝壳录一句吧',
    'chat.bottle.list.noText': '（无文字）',
    'chat.bottle.list.playing': '播放中…',
    'chat.bottle.list.play': '▶ 播放',
    'chat.bottle.list.delete': '删除',

    // VoiceBottleModal — errors
    'chat.bottle.error.unsupported': '当前浏览器不支持录音哦～换 Safari 或 Chrome 试试',
    'chat.bottle.error.micDenied': '需要打开麦克风权限才能留言哦',
    'chat.bottle.error.recorderFailed': '录音器打不开，重新试试吧',
    'chat.bottle.error.tooShort': '录得太短啦，多说几个字试试～',
    'chat.bottle.error.saveFailed': '留言瓶没装好，再来一次吧',

    // VoiceBottleModal — backend ack template
    'chat.bottle.ack.fromPet': '{name}：{message}',
  },
  en: {
    // ChatPage — empty/no-pet state
    'chat.empty.noPet.title': 'Adopt a pet first',
    'chat.empty.noPet.helper': 'You need a friend to chat with~',
    'chat.empty.noPet.cta': '🐾 Go adopt',

    // ChatPage — empty conversation
    'chat.empty.greet': 'Say hi to {name}~',

    // ChatPage — input
    'chat.input.placeholder': 'Talk to {name}...',

    // ChatPage — budget warning
    'chat.budget.nearLimit': "The AI's chatted a lot today and is almost out of energy. Tomorrow it'll be peppier!",

    // ChatPage — error fallback
    'chat.error.generic': 'Something went wrong',

    // VoiceBottleModal — header
    'chat.bottle.title': 'Whisper bottle',
    'chat.bottle.subtitle': 'Say something to {name} — they will remember forever',
    'chat.bottle.close.aria': 'Close',

    // VoiceBottleModal — idle / record
    'chat.bottle.hint': 'Hold the shell to talk, let go to drop it in the bottle',
    'chat.bottle.recordHold': 'Hold to record',
    'chat.bottle.recordRelease': 'Let go to finish',

    // VoiceBottleModal — recording info
    'chat.bottle.timer': '{seconds}s · max {max}s',
    'chat.bottle.duration': '{seconds}s',

    // VoiceBottleModal — preview
    'chat.bottle.preview.recorded': '✨ Got it! Length {duration}',
    'chat.bottle.preview.noTranscript': "(No words came through this time, but {name} will still remember you recorded a whisper)",
    'chat.bottle.preview.redo': 'Redo',
    'chat.bottle.preview.save': 'Drop in bottle',

    // VoiceBottleModal — saving
    'chat.bottle.saving': 'Letting {name} listen…',

    // VoiceBottleModal — list
    'chat.bottle.list.title': 'In the bottle ({count})',
    'chat.bottle.list.empty': 'No whispers yet~ hold the shell and record one',
    'chat.bottle.list.noText': '(no text)',
    'chat.bottle.list.playing': 'Playing…',
    'chat.bottle.list.play': '▶ Play',
    'chat.bottle.list.delete': 'Delete',

    // VoiceBottleModal — errors
    'chat.bottle.error.unsupported': "This browser can't record~ try Safari or Chrome",
    'chat.bottle.error.micDenied': 'We need microphone permission to leave a whisper',
    'chat.bottle.error.recorderFailed': "The recorder won't open, please try again",
    'chat.bottle.error.tooShort': 'Too short! Say a few more words~',
    'chat.bottle.error.saveFailed': "The bottle didn't seal — try once more",

    // VoiceBottleModal — backend ack template
    'chat.bottle.ack.fromPet': '{name}: {message}',
  },
};

export default chat;
